/**
 * The external dependencies.
 */
import React from 'react';
import styled from 'styled-components';
/**
 * The internal dependencies.
 */
import Button from '../../../../components/general/button';
import Chevron from '../../../../components/general/navigation-chevron';

const ActionButton = styled(Button)`
	display: flex;
	align-items: center;
	justify-content: center;

	width: 244px;
	font-size: 19px;
	border-width: 0;
	background: ${({disabled}) => disabled ? '#e5e8ea' : '#fff'};

	${({disabled}) =>
    disabled
        ? `
				color: #fff;
				border-color: #fff;

				& span {
					border-color: #fff;
				}
			`
        : ''
    };

	${({disabled}) => disabled
    ? `
			&:hover {
				background: #e5e8ea;
				color: #fff;
			}
		`
    : ''
    }
`;

const Actions = ({disabled, handleClick}) => (
    <ActionButton disabled={disabled} onClick={disabled ? null : handleClick}>
        Fehler jetzt melden

        <Chevron/>
    </ActionButton>
);

export default Actions;



// WEBPACK FOOTER //
// ./src/components/task/working/report/actions.js